export default __webpack_public_path__ + "static/favicon-89080274eed52011ef84845c9a3c24ec.ico";